module.exports = __webpack_public_path__ + "static/SocialMedia-c3ad17e2c02e420aef95f974b3d9e59f.jpg";